export const interiorView09ImageOptions = {
	angle:"InteriorView09",
	staticOptions:{
		PortAftCabinOptions:1,
		StarboardAftCabinOptions:1,
		Floorboard:1,
		Worktop:1,
		StarboardAftCabin:1,
		FabricSaloon:1,
		CupboardsOwnersCabin:1,
		Mast:1,
		TableBox:1,
		Pouffes:1,
		FabricCabins:1,
	},
	mattes:[
	],
	overlays:[
	]
};



// WEBPACK FOOTER //
// ./src/X46MK2/views/InteriorView09.js